import { Gradient } from '@shared-ui/components/ui/gradient'
import { useCreateStyles } from '@shared-ui/components/ui/screen-wrappers/status-bar-gradient/styles'
import { useAppTheme } from '@shared-ui/theme'
import { Platform } from 'react-native'
import Animated, { useAnimatedStyle, withTiming } from 'react-native-reanimated'

type StatusBarGradientProps = {
  isVisible: boolean
}

export function StatusBarGradient(props: StatusBarGradientProps) {
  const styles = useCreateStyles()
  const theme = useAppTheme()
  const animatedStyle = useAnimatedStyle(
    () => ({
      opacity: withTiming(props.isVisible ? 1 : 0, { duration: 150 }),
    }),
    Platform.OS === 'web' ? [props.isVisible] : undefined,
  )

  return (
    <Animated.View style={[styles.statusBarWrapper, animatedStyle]}>
      <Gradient
        style={styles.statusBarStyle}
        colors={[`${theme.COLOR_BG_BASE}08`, theme.COLOR_BG_BASE]}
        locations={[0, 1]}
        start={{ x: 0, y: 1 }}
        end={{ x: 0, y: 0 }}
      />
    </Animated.View>
  )
}
